import PropTypes from 'prop-types';

export const propTypes = {includedExtrasAndDriversSelector: PropTypes.array,
  addedExtras: PropTypes.array,
  selectedBundle: PropTypes.object,
  numberOfExtrasSelected: PropTypes.number,
  addedExtrasAmount: PropTypes.number,
  bundledAdditionalDrivers: PropTypes.number,};
